import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/151bbf66-e948-4917-8b2a-7b8d15379d1d.jpg';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full overflow-hidden bg-vm-bg" data-id="element-95" data-mp="9l34fchccc3z">
      <div className="absolute inset-0" aria-hidden="true" data-id="element-96" data-mp="4na0kq3ifu6v">
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover" data-id="element-97" data-mp="12a0it4iflorg" />
        <div className="absolute inset-0 bg-vm-bg/80" data-id="element-98" data-mp="xae6qyecaek8" />
      </div>

      <div className="relative z-10 flex w-full flex-col justify-between px-6 pb-8 pt-44 lg:px-10 lg:pb-10 lg:pt-32" data-id="element-99" data-mp="xb5rfe6eervq">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-7xl" data-id="element-100" data-mp="sd4d16jx3gql">
          <p className="mb-7 text-xs font-medium uppercase tracking-[0.25em] text-vm-muted" data-id="element-101" data-mp="3825y4q50c7ld">
            Tecnología visual en movimiento
          </p>

          <h1 className="max-w-full font-syne text-[clamp(37px,10.5vw,48px)] font-extrabold uppercase leading-[1.05] tracking-[-0.04em] text-white lg:text-[clamp(68px,6vw,96px)] lg:leading-[1.11]" data-id="element-102" data-mp="3j6fw9kdl53b7">
            <span className="block" data-id="element-103" data-mp="39cfkx0rpn1u1">Creamos historias</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-104" data-mp="3e8ecsyc8z1z7">que conectan</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-105" data-mp="30fy8zvbiuzx8">marcas <span className="text-white" data-id="element-106" data-mp="2qk3k4igpg8m0">con</span></span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-107" data-mp="2qloh0eqhs3n1">personas</span>
          </h1>

          <a href="#contacto" className="mt-9 inline-flex items-center gap-3 rounded-[4px] bg-vm-blue px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-white shadow-lg shadow-black/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-vm-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg" data-id="element-108" data-mp="2hix2g62bkrr6">
            <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="icrnupbfmj8p" />
            Conversemos tu proyecto
          </a>
        </motion.div>

        <div className="mx-auto mt-10 flex w-full max-w-7xl items-center justify-between border-t border-white/20 pt-5 text-[10px] font-medium uppercase tracking-[0.25em] text-vm-muted sm:text-xs" data-id="element-110" data-mp="1b0vw9ile1af3">
          <span data-id="element-111" data-mp="112px38qyuidx">Vivo Media</span>
          <span data-id="element-112" data-mp="111yb8pn67z0u">Desde Uruguay</span>
        </div>
      </div>
    </section>;
}